import * as yup from 'yup';

export interface IVerifyEmail {
	code: string;
}

export const verifyEmailSecureInitialValues: IVerifyEmail = {
	code: '',
};

export const verifyEmailSecureSchema = yup.object().shape({
	code: yup.string().required('generalForm:required'),
});
